/* Sleep Reset System bundle page (sections/pp-srs.liquid) */
(function(){
  function init(root){
    if(root.dataset.srsReady) return; root.dataset.srsReady='1';
    root.classList.add('srs-js');
    var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

    /* gallery */
    var slides=[].slice.call(root.querySelectorAll('[data-srs-slide]')), thumbs=[].slice.call(root.querySelectorAll('[data-srs-thumb]')), count=root.querySelector('[data-srs-count]'), at=0;
    var pad=function(n){return (n<10?'0':'')+n;};
    function show(i){
      if(!slides.length) return;
      at=(i+slides.length)%slides.length;
      slides.forEach(function(s,j){s.hidden=j!==at;});
      thumbs.forEach(function(t,j){t.classList.toggle('is-on',j===at);t.setAttribute('aria-pressed',j===at?'true':'false');});
      if(count) count.textContent=pad(at+1)+' / '+pad(slides.length);
      var lazy=slides[at].querySelector('img[loading=lazy]'); if(lazy) lazy.loading='eager';
    }
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){show(i);});});
    root.querySelectorAll('[data-srs-prev]').forEach(function(b){b.addEventListener('click',function(){show(at-1);});});
    root.querySelectorAll('[data-srs-next]').forEach(function(b){b.addEventListener('click',function(){show(at+1);});});
    var stage=root.querySelector('[data-srs-stage]'), x0=null;
    if(stage){
      stage.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
      stage.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)show(at+(dx<0?1:-1));x0=null;},{passive:true});
      stage.addEventListener('keydown',function(e){if(e.key==='ArrowRight')show(at+1);if(e.key==='ArrowLeft')show(at-1);});
    }
    show(0);

    /* variants */
    var vj=root.querySelector('[data-srs-variants]'), variants=vj?JSON.parse(vj.textContent):[];
    var buys=[].slice.call(root.querySelectorAll('[data-srs-buy]')), adds=[].slice.call(root.querySelectorAll('[data-srs-add]'));
    var msg=root.querySelector('[data-srs-msg]'), sel={}, current=null, nOpts=root.querySelectorAll('[data-srs-optgroup]').length;
    root.querySelectorAll('[data-srs-opt][aria-pressed="true"]').forEach(function(b){sel[b.dataset.srsOpt]=b.dataset.value;});
    function setLabel(b,t){b.textContent=t;}
    function sync(){
      var picked=Object.keys(sel).length;
      current=picked>=nOpts?(variants.find(function(v){return Object.keys(sel).every(function(p){return v['option'+p]===sel[p];});})||null):null;
      root.querySelectorAll('[data-srs-optval]').forEach(function(el){el.textContent=sel[el.dataset.srsOptval]||'';});
      var ok=current&&current.available, need=root.dataset.needSize;
      buys.forEach(function(b){
        b.disabled=false;
        if(picked<nOpts) setLabel(b,b.dataset.short?root.dataset.labelShort:need);
        else if(!ok){b.disabled=true;setLabel(b,current?'Sold out in this size':'Unavailable');}
        else setLabel(b,b.dataset.short?root.dataset.labelShort:root.dataset.label);
      });
      adds.forEach(function(b){b.disabled=!ok;});
    }
    root.querySelectorAll('[data-srs-opt]').forEach(function(b){
      b.addEventListener('click',function(){
        root.querySelectorAll('[data-srs-opt="'+b.dataset.srsOpt+'"]').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});
        sel[b.dataset.srsOpt]=b.dataset.value; if(msg) msg.textContent=''; sync();
      });
    });
    sync();

    function goBuy(){
      var card=root.querySelector('#buy'); if(!card) return;
      card.scrollIntoView({behavior:'smooth',block:'center'});
      var first=card.querySelector('[data-srs-optgroup]:not(.is-done) [data-srs-opt]');
      if(msg) msg.textContent='Choose your ring size to continue.';
      setTimeout(function(){var g=null;card.querySelectorAll('[data-srs-optgroup]').forEach(function(gr){if(!g&&!sel[gr.dataset.srsOptgroup])g=gr;});var f=g&&g.querySelector('[data-srs-opt]');if(f)f.focus({preventScroll:true});},500);
    }
    function add(then){
      if(!current||!current.available){goBuy();return;}
      var all=buys.concat(adds); all.forEach(function(b){b.disabled=true;});
      fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:current.id,quantity:1}]})})
        .then(function(r){return r.json().then(function(d){if(!r.ok) throw d; return d;});})
        .then(function(){
          if(then==='checkout'){location.href=base+'checkout';return;}
          location.href=base+'cart';
        })
        .catch(function(err){all.forEach(function(b){b.disabled=false;});if(msg) msg.textContent=(err&&err.description)||'Something went wrong. Please try again.';});
    }
    buys.forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();add('checkout');});});
    adds.forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();add('cart');});});
    root.querySelectorAll('[data-srs-jump]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();goBuy();if(msg&&current)msg.textContent='';});});

    /* sticky bar: shown once the buy card has scrolled away, hidden near the end */
    var sticky=root.querySelector('[data-srs-sticky]'), card=root.querySelector('#buy');
    if(sticky&&card){
      var onScroll=function(){var r=card.getBoundingClientRect();var past=r.bottom<0;var nearEnd=window.innerHeight+window.scrollY>document.documentElement.scrollHeight-600;sticky.classList.toggle('is-on',past&&!nearEnd);sticky.setAttribute('aria-hidden',past&&!nearEnd?'false':'true');};
      window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
    }

    /* reveal + chart */
    var els=[].slice.call(root.querySelectorAll('[data-reveal],[data-srs-chart]'));
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -10% 0px'});
      els.forEach(function(el){io.observe(el);});
    } else els.forEach(function(el){el.classList.add('is-in');});
  }
  function boot(){document.querySelectorAll('.srs').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
